import React, { FunctionComponent } from 'react'
import Row from '../Common/Row'
import { BookIcon, CalendarIcon, LockIcon, ScheduleIcon } from '../Icons'
import { Text } from '@wework/dieter-ui'
import css from './BookableSpaceAttributes.module.scss'

interface BookableSpaceAttributesProps {
  space: any // TODO: change type when space model will be defined
}

const BookableSpaceAttributes: FunctionComponent<BookableSpaceAttributesProps> = ({
  space,
}) => {
  const openDate = '12 Jan 2020'
  const closeDate = '12 Jan 2022'
  const isFreeToBook = true
  const isPrivate = true
  return (
    <>
      {isPrivate && (
        <Row className={css.attributeRow} justify={'flex-start'}>
          <LockIcon color={'#000000'} />
          <Text className={css.attributeTitle}>Private room</Text>
        </Row>
      )}
      {isFreeToBook && (
        <Row className={css.attributeRow} justify={'flex-start'}>
          <BookIcon />
          <Text className={css.attributeTitle}>Free to book</Text>
        </Row>
      )}
      <Row className={css.attributeRow} justify={'flex-start'}>
        <ScheduleIcon />
        <Text className={css.attributeTitle}>Book up to 7 days ah≥ead</Text>
      </Row>
      <Row className={css.attributeRow} justify={'flex-start'}>
        <CalendarIcon />
        <div className={css.titleGroup}>
          <Text className={css.attributeTitle}>{`Opened ${openDate}`}</Text>
          <Text className={css.attributeTitle}>{`Closed ${closeDate}`}</Text>
        </div>
      </Row>
    </>
  )
}

export default BookableSpaceAttributes
